import React from 'react';
import { Percent, TrendingDown } from 'lucide-react';

export default function CTRCard() {
  return (
    <div className="bg-white border border-[#e7e7e7] rounded-[5px] p-5 hover:shadow-[rgba(150,25,50,0.1)_0px_10px_30px] transition-all duration-200 hover:-translate-y-0.5">
      <div className="flex items-start justify-between mb-4">
        <div>
          <p className="text-xs font-500 uppercase tracking-wide text-[#696969] mb-1">
            Branded CTR
          </p>
          <p className="text-3xl font-700 tabular-nums text-[#39364E]">
            30.7%
          </p>
          <p className="text-xs text-[#696969] mt-1">7-day average</p>
        </div>
        {/* Smarty-style icon wrapper: purple bg */}
        <div
          className="w-[50px] h-[50px] rounded-[5px] flex items-center justify-center"
          style={{ backgroundColor: 'rgb(240, 228, 251)' }}
        >
          <Percent size={22} className="text-[#39364E]" />
        </div>
      </div>
      <div className="flex items-center gap-1.5">
        <div className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-red-50 border border-red-200">
          <TrendingDown size={11} className="text-red-500" />
          <span className="text-[11px] font-600 text-red-600 tabular-nums">−2.3pp</span>
        </div>
        <span className="text-[11px] text-[#696969]">vs prev period</span>
      </div>
      <div className="mt-4">
        <div className="flex justify-between text-[11px] text-[#696969] mb-1">
          <span>vs site avg CTR</span>
          <span className="font-500 text-[#39364E] tabular-nums">+11.4pp</span>
        </div>
        <div className="h-1.5 bg-[rgba(150,25,50,0.08)] rounded-full overflow-hidden">
          <div className="h-full bg-[#961932] rounded-full" style={{ width: '72%' }} />
        </div>
      </div>
    </div>
  );
}